import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

window.addEventListener("load", () => {

  (() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const containers = document.querySelectorAll('.gs-from-bottom');
    const viewportHeight = window.innerHeight;

    // READ phase: measure every child up front. Doing this before any writes
    // (gsap.set/gsap.from below) avoids forced synchronous reflow — reading
    // getBoundingClientRect() right after a style/DOM write is what forces
    // the browser to flush layout early; batching all reads together lets
    // it happen once instead of once per element.
    const entries = [];
    containers.forEach((container) => {
      [...container.children].forEach((child) => {
        const rect = child.getBoundingClientRect();
        const isAlreadyVisible = rect.bottom > 0 && rect.top < viewportHeight;
        entries.push({ child, isAlreadyVisible });
      });
    });

    // WRITE phase: apply styles/animations, no more geometry reads in between.
    entries.forEach(({ child, isAlreadyVisible }) => {
      // Element (or part of it) is already visible when the page loads, or the
      // user has requested reduced motion — keep it visible as-is, don't animate it.
      if (isAlreadyVisible || prefersReducedMotion) {
        gsap.set(child, { clearProps: "opacity,transform" });
        return;
      }

      gsap.from(child, {
        opacity: 0,
        y: 50,
        ease: "none",
        scrollTrigger: {
          trigger: child,
          start: "top 100%",
          end: "top 50%",
          scrub: true,
          invalidateOnRefresh: true
        }
      });
    });
  })();



});
